import { Flight } from "@ibe/models";

/**
 * State for total summary component
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	payload: { flights: Flight[], summary: Array<{ item: string, label: string, value: string, total: string }> };
}

export const initialState: State = {
	loading: false,
	payload: { flights: [], summary: [] },
};
